import React, { useState } from "react";
import { useSelector } from "react-redux";
import get from "lodash/get";
import { DfpComponent } from "../../ads/dfp-component";
import "./india-gold-duty-calculator.m.css";

export const GoldDutyCalculator = () => {
  const rowAdConfig = useSelector((state) =>
    get(state, ["qt", "config", "ads-config", "slots", "section_page_adslot_1"], {})
  );
  const [stay, setStay] = useState("less6");
  const [gender, setGender] = useState("male");
  const [goldType, setGoldType] = useState("jewellery");
  const [weight, setWeight] = useState("");
  const [pricePerGram, setPricePerGram] = useState("");
  const [aedtoinr, setAedtoinr] = useState(24);
  const [duty, setDuty] = useState(null);

  const calculateDuty = () => {
    const weightNum = parseFloat(weight) || 0;
    const pricePerGramAED = parseFloat(pricePerGram) || 0;
    if (!weightNum || !pricePerGramAED) {
      return;
    }
    const pricePerGramINR = pricePerGramAED * aedtoinr;
    const valueAed = weightNum * pricePerGramAED;
    const value = weightNum * pricePerGramINR;

    let exemptionValue = 0;
    if (goldType === "jewellery" && stay === "more12") {
      const maxWeight = gender === "male" ? 20 : 40;
      const maxValue = gender === "male" ? 50000 : 100000;
      const weightValue = Math.min(weightNum, maxWeight) * pricePerGramINR;
      exemptionValue = Math.min(weightValue, maxValue);
    }

    const dutiableValue = goldType === "jewellery" ? Math.max(0, value - exemptionValue) : value;
    let exemptionNote = "";
    let dutyRate = stay === "more12" || stay === "6to12" ? 13.75 : 38.5;

    if (stay === "more12") {
      if (goldType === "jewellery") {
        // Apply jewellery duty-free allowance
        const freeGrams = gender === "male" ? 20 : 40;
        const freeValue = gender === "male" ? 50000 : 100000;
        exemptionNote = `Jewellery exemption applied: ${freeGrams}g (up to ₹${freeValue.toLocaleString()})`;
        if (gender === "male") {
          if (weightNum <= 50) {
            dutyRate = 3;
          }
          if (weightNum > 50 && weightNum <= 100) {
            dutyRate = 6;
          }
          if (weightNum > 100) {
            dutyRate = 10;
          }
        } else {
          if (weightNum <= 100) {
            dutyRate = 3;
          }
          if (weightNum > 100 && weightNum <= 200) {
            dutyRate = 6;
          }
          if (weightNum > 200) {
            dutyRate = 10;
          }
        }
      } else {
        // Bars/Coins → no exemption
        exemptionNote = "⚠️ No duty-free exemption on bars/coins — full value is taxable.";
      }
    }

    const dutyAmount = (dutiableValue * dutyRate) / 100; // GST @ 3% on (value + duty)

    const gst = (dutiableValue + dutyAmount) * 0.03; // Final total payable

    const total = dutyAmount + gst;
    let totalAed = 0;
    if (total > 0) {
      totalAed = (total / aedtoinr).toFixed(2);
    }

    setDuty({
      value,
      dutiableValue,
      dutyRate: dutyRate + "%",
      dutyAmount,
      gst,
      total,
      totalAed,
      valueAed,
      exemptionNote,
    });
  };
  const handleReset = () => {
    setStay("less6");
    setGender("male");
    setGoldType("jewellery");
    setWeight("");
    setPricePerGram("");
    setAedtoinr(24);
    setDuty(null);
  };
  return (
    <div styleName="india-gold-duty-calculator">
      <div styleName="calculator-container">
        <div styleName="calculator">
          <h2 styleName="title">Gold Customs Duty Calculator - India </h2>
          <div styleName="input-row">
            <label styleName="label">Stay Duration Abroad</label>
            <select value={stay} onChange={(e) => setStay(e.target.value)}>
              <option value="less6">Less than 6 months</option> <option value="6to12">6 to 12 months</option>
              <option value="more12">More than 1 year</option>
            </select>
          </div>
          <div styleName="input-row">
            <label styleName="label">Gold Type</label>
            <select value={goldType} onChange={(e) => setGoldType(e.target.value)}>
              <option value="jewellery">Jewellery</option>
              <option value="bars">Bars</option>
              <option value="bars">Coins</option>
            </select>
          </div>
          {stay === "more12" && goldType === "jewellery" && (
            <div styleName="input-row">
              <label styleName="label">Gender</label>
              <select value={gender} onChange={(e) => setGender(e.target.value)}>
                <option value="male">Male</option>
                <option value="female">Female</option>
              </select>
            </div>
          )}
          <div styleName="input-row">
            <label styleName="label">Gold Weight (grams)</label>
            <input type="number" value={weight} onChange={(e) => setWeight(e.target.value)} />
          </div>
          <div styleName="input-row">
            <label styleName="label">
              Exchange rate (AED to INR)&nbsp;
              <a href="/gold-forex" target="_blank">
                See Exchange rate
              </a>
            </label>
            <input
              type="number"
              value={aedtoinr}
              onChange={(e) => setAedtoinr(e.target.value)}
              placeholder="Exchange rate (AED to INR)"
            />
          </div>
          <div styleName="input-row">
            <label styleName="label">
              Gold Price per gram (AED)&nbsp;
              <a href="/gold-forex#gold-rate" target="_blank">
                See Gold rate
              </a>
            </label>
            <input type="number" value={pricePerGram} onChange={(e) => setPricePerGram(e.target.value)} />
          </div>
          <button onClick={calculateDuty} styleName="submit">
            Calculate Duty
          </button>
          <button styleName="reset" onClick={handleReset}>
            Reset
          </button>
          {duty && (
            <div styleName="result">
              <p>
                Total Gold Value: <span>₹{duty.value.toLocaleString()}</span> (AED {duty.valueAed.toLocaleString()})
              </p>
              <p>
                Dutiable Value: <span>₹{duty.dutiableValue.toLocaleString()}</span>
              </p>
              <p>
                Duty Rate: <span>{duty.dutyRate}</span>
              </p>
              <p>
                Customs Duty: <span>₹{duty.dutyAmount.toLocaleString()}</span>
              </p>
              <p>
                GST (3%): <span>₹{duty.gst.toLocaleString()}</span>
              </p>
              {duty.exemptionNote && <p>{duty.exemptionNote}</p>}
              <p styleName="tot-amt">
                Total Payable:
                <span>₹{duty.total.toLocaleString()}</span> (AED {duty.totalAed.toLocaleString()})
              </p>
            </div>
          )}
        </div>
        <div styleName="info">
          <div styleName="txt-title">How India Gold duty is calculated</div>
          <label>
            For Indian expats returning from Dubai, customs duty on gold depends on your duration of stay abroad, per
            Baggage Rules, 2016 and CBIC guidelines:
          </label>
          <ul>
            <li>
              <strong>Abroad for more than 1 year:</strong> Men can bring 20g, Women 40g jewellery duty-free. Coins,
              bars, and biscuits always attract duty.
            </li>
            <li>
              <strong>6-12 months abroad:</strong> Up to 1 kg of gold in any form can be imported at 13.75% duty.{" "}
            </li>
            <li>
              <strong>Less than 6 months abroad:</strong> Duty is about 38.5%, with no allowance.
            </li>
            <li>
              <strong>Extra jewellery duty:</strong> Men 20-50g: 3%, 50-100g: 6%, > 100g: 10%; Women 40-100g: 3%,
              100-200g: 6%, > 200g: 10%.
            </li>
            <li>
              <strong>Tips:</strong> Declare gold at Red Channel, carry invoices, and pay via low-fee methods.
            </li>
          </ul>
        </div>
        <div styleName="disclaimer-txt">
          <h3>DISCLAIMER</h3>
          <p>
            This information outlines general rules on gold duty for returning Indian residents based on publicly
            available guidelines. Actual charges can vary by airport, documentation, and assessment by customs officers.
            Always confirm current rates and eligibility with CBIC or airport customs before travel.
          </p>
        </div>
      </div>
      <div styleName="rowAd">
        <DfpComponent
          adStyleName="ad-slot-size-300x600"
          id={`gold-duty-page-right-ad`}
          path={"/1019334/GULFNEWS/Gulfnews_ATF/gulfnews_goldforex_atf/gulfnews_goldforex_right_atf"}
          size={rowAdConfig?.sizes}
          viewPortSizeMapping={rowAdConfig?.view_port_size_mapping}
        />
      </div>
    </div>
  );
};
